import React from 'react'
import { Text } from '@chatterbug/aaron'
import { t } from 'src/lib/i18n-react'

import { TYPES } from 'src/pages/Achievements/subcomponents/AchievementWidget/AchievementWidget'

import WidgetImage from './subcomponents/WidgetImage/WidgetImage'
import AchievementWidgetBodySkeleton from './AchievementWidgetBodySkeleton'
import WidgetDetail from './subcomponents/WidgetDetail/WidgetDetail'

const AchievementWidgetBody = ({
  activityInfo,
  widgetType,
  showPlaceholder,
  liveLessonInfo,
  // bool for listview style
  isList = false,
}) => {
  return (
    <AchievementWidgetBodySkeleton
      showPlaceholder={showPlaceholder}
      widgetType={widgetType}
      isList={isList}
      titleSection={
        widgetType === TYPES.LIVE_LESSON ? null : showPlaceholder ? null : (
          <Text mb="1x" variant="text.tinyTitle">
            {t('Recently studied')}
          </Text>
        )
      }
      imageSection={
        <WidgetImage
          {...liveLessonInfo}
          {...activityInfo}
          widgetType={widgetType}
          showPlaceholder={showPlaceholder}
          isList={isList}
        />
      }
      detailSection={
        <WidgetDetail
          {...liveLessonInfo}
          {...activityInfo}
          widgetType={widgetType}
          showPlaceholder={showPlaceholder}
          isList={isList}
        />
      }
    />
  )
}

export default AchievementWidgetBody
